import { FundEntityReadData } from "gen/model/fundEntityReadData";
import { useTranslation } from "react-i18next";
import { SelectButton } from "shared/components/input/select/SelectButton";
import { SelectOption } from "shared/components/input/select/SelectOption";

export interface FundSelectButtonProps {
  funds: FundEntityReadData[];
  selectedFundIds: string[] | undefined | null;
  onSelectedFundIdsChange: (selectedFundIds: string[]) => void;
}

export const FundSelectButton: React.FC<FundSelectButtonProps> = ({
  funds,
  selectedFundIds,
  onSelectedFundIdsChange,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <SelectButton
      value={selectedFundIds}
      onChangeValue={onSelectedFundIdsChange}
      title={t("common:funds")}
      isFilterButton={true}
      isMulti={true}
      size="sm"
    >
      {funds.map((fund) => (
        <SelectOption key={fund.id} value={fund.id}>
          {fund.legal_name}
        </SelectOption>
      ))}
    </SelectButton>
  );
};
